// Mileage allowance (audit ADM-17): 2,500 km per 30 days between the first pick-up and the contract end.
// Without both dates there is no allowance to compare with - it is null, never 0 (0 charged every kilometre).
export const KM_PER_30_DAYS = 2500;

const dayOf = (ymd) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(ymd || ''));
    return m ? Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};

/** {days, allowedKm, exceededKm}; allowedKm / exceededKm are null when a date is missing. */
export function mileageAllowance(startYmd, endYmd, usedKm) {
    const start = dayOf(startYmd);
    const end = dayOf(endYmd);
    if (start === null || end === null) return { days: null, allowedKm: null, exceededKm: null };
    const days = Math.max(0, Math.floor((end - start) / 86400000));
    const allowedKm = Math.floor((days / 30) * KM_PER_30_DAYS);
    return { days, allowedKm, exceededKm: Math.max(0, (Number(usedKm) || 0) - allowedKm) };
}
